import { render, staticRenderFns } from "./ChatConfigurationTile.vue?vue&type=template&id=6f070846&lang=pug&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChatConfigurationTile.vue"
export default component.exports